import {
  HomeIcon,
  LocationMarkerIcon,
  UserIcon
} from "@heroicons/react/outline";
import React from "react";
import { useHistory, useLocation } from "react-router";
import { matchPath, Route, Switch } from "react-router-dom";
import BoxIcon from "../../../components/icons/BoxIcon";
import HexIcon from "../../../components/icons/HexIcon";
import NavLink from "../../../components/NavLink";
import PrivateRoute from "../../../layout/PrivateRoute";
import ContactsList from "./ContactsList";
import HexesList from "./HexesList";
import HotspotsTab from "./HotspotsTab";
import InstallsList from "./InstallsList";
import LocationsList from "./LocationsList";

interface Props {}

const SideMenu: React.FC<Props> = () => {
  const history = useHistory();
  const { pathname } = useLocation();

  const pathMatch = matchPath<{
    tab: "hotspots" | "locations" | "hexes" | "contacts" | "installs";
    id?: string;
  }>(pathname, {
    path: [":tab/:id", "/:tab"]
  });

  return (
    <>
      <div className="mt-14 sm:mt-0 px-3 sm:px-0">
        <select
          className="sm:hidden block w-full pl-3 py-2 sm:text-sm rounded-md dark:bg-gray-800"
          onChange={(e) => {
            history.push(`/${e.target.value}`);
          }}
          value={pathMatch?.params.tab}
        >
          {tabs.map(({ key, title }) => (
            <option key={key} value={key}>
              {title}
            </option>
          ))}
        </select>
        <div className="hidden sm:block border-b border-gray-200 dark:border-gray-500">
          <nav className="-mb-px flex" aria-label="Tabs">
            {tabs.map(({ key, title, Icon }) => (
              <NavLink
                key={key}
                to={`/${key}`}
                activeClassName="border-hotspotty-400 text-hotspotty-500 dark:text-white dark:border-white"
                inactiveClassName="border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group dark:text-gray-400 dark:hover:text-gray-300"
                className="inline-flex justify-center items-center py-4 px-3 border-b-2 font-medium text-sm w-1/8 xl:w-1/2"
              >
                <Icon className="h-5 w-5" />
                {pathMatch?.params.tab === key && (
                  <span className="ml-2">{title}</span>
                )}
              </NavLink>
            ))}
          </nav>
        </div>
      </div>
      <Switch>
        <Route path="/hotspots" component={HotspotsTab} />
        <Route path="/hexes" component={HexesList} />
        <PrivateRoute path="/locations" component={LocationsList} />
        <PrivateRoute path="/contacts" component={ContactsList} />
        <PrivateRoute path="/installs" component={InstallsList} />
      </Switch>
    </>
  );
};

export default SideMenu;

//
// Utils
//

const tabs = [
  { key: "hotspots", title: "Hotspots", Icon: BoxIcon },
  { key: "hexes", title: "Hexes", Icon: HexIcon },
  { key: "locations", title: "Locations", Icon: LocationMarkerIcon },
  { key: "contacts", title: "Contacts", Icon: UserIcon },
  { key: "installs", title: "Installs", Icon: HomeIcon }
];
